import { call, put, takeLatest } from 'redux-saga/effects';
import {
  ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_BEGIN,
  ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_SUCCESS,
  ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_FAILURE,
  ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_DISMISS_ERROR,
} from './constants';
import { protectedJsonPost } from '../../../utils/api';

export function addProjectFields(accountId, data) {
  return {
    type: ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_BEGIN,
    accountId,
    data,
  };
}

export function dismissAddProjectFieldsError() {
  return {
    type: ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_DISMISS_ERROR,
  };
}

export function* doAddProjectFields(action) {
  const { accountId, data } = action;
  let res;
  try {
    res = yield call(protectedJsonPost, `accounts/${accountId}/project-fields`, data);
  } catch (err) {
    yield put({
      type: ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_SUCCESS,
    data: res,
  });
}

export function* watchAddProjectFields() {
  yield takeLatest(ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_BEGIN, doAddProjectFields);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_BEGIN:
      return {
        ...state,
        addProjectFieldsPending: true,
        addProjectFieldsError: null,
      };

    case ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_SUCCESS: {
      const newProjectFieldList = [...state.projectFields, ...action.data];

      return {
        ...state,
        projectFields: newProjectFieldList,
        addProjectFieldsPending: false,
        addProjectFieldsError: null,
      };
    }

    case ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_FAILURE:
      return {
        ...state,
        addProjectFieldsPending: false,
        addProjectFieldsError: action.data.error,
      };

    case ACCOUNT_SETTINGS_ADD_PROJECT_FIELDS_DISMISS_ERROR:
      return {
        ...state,
        addProjectFieldsError: null,
      };

    default:
      return state;
  }
}
